import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Inbox } from "lucide-react";
import { api } from "@/lib/api";
import { QUOTE_STATUSES, fmtDate } from "@/lib/constants";
import StatusBadge from "@/components/admin/StatusBadge";

export default function Quotes() {
  const [quotes, setQuotes] = useState(null);
  const [filter, setFilter] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/admin/quotes${filter ? `?status=${filter}` : ""}`).then((r) => setQuotes(r.data)).catch(() => setQuotes([]));
  }, [filter]);

  return (
    <div data-testid="admin-quotes">
      <h1 className="font-display font-semibold text-2xl sm:text-3xl text-ink">Demandes de devis</h1>
      <p className="mt-1 text-sm text-muted2">Toutes les demandes envoyées depuis le site arrivent ici automatiquement.</p>

      <div className="mt-6 flex gap-2 overflow-x-auto pb-2 -mx-1 px-1" data-testid="quotes-filters">
        <button
          onClick={() => setFilter("")}
          data-testid="filter-all"
          className={`shrink-0 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${!filter ? "bg-forest text-cream" : "bg-white text-body2 border border-line"}`}
        >
          Toutes
        </button>
        {QUOTE_STATUSES.map((s) => (
          <button
            key={s.key}
            onClick={() => setFilter(s.key)}
            data-testid={`filter-${s.key}`}
            className={`shrink-0 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${filter === s.key ? "bg-forest text-cream" : "bg-white text-body2 border border-line"}`}
          >
            {s.label}
          </button>
        ))}
      </div>

      {!quotes ? (
        <p className="mt-10 text-sm text-muted2">Chargement…</p>
      ) : quotes.length === 0 ? (
        <div className="mt-8 rounded-2xl border border-dashed border-line bg-white p-12 text-center" data-testid="quotes-empty">
          <Inbox className="h-8 w-8 text-line mx-auto" />
          <p className="mt-3 text-sm text-muted2">Aucune demande pour ce filtre.</p>
        </div>
      ) : (
        <div className="mt-6 rounded-2xl bg-white border border-line overflow-hidden">
          <ul className="divide-y divide-line">
            {quotes.map((q) => (
              <li key={q.id}>
                <button
                  onClick={() => navigate(`/admin/demandes/${q.id}`)}
                  data-testid={`quote-row-${q.id}`}
                  className="w-full text-left px-5 py-4 hover:bg-cream/60 transition-colors flex flex-wrap items-center gap-x-4 gap-y-1.5"
                >
                  <span className="font-semibold text-ink text-sm min-w-[130px]">{q.name}</span>
                  <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${q.client_type === "professionnel" ? "bg-forest/10 text-forest" : "bg-sand text-body2"}`}>
                    {q.client_type === "professionnel" ? "Professionnel" : "Particulier"}
                  </span>
                  <span className="text-xs text-muted2 hidden sm:inline">{q.need_type}</span>
                  <span className="text-xs text-muted2">{q.phone}</span>
                  <span className="text-xs text-muted2 ml-auto hidden md:inline">{fmtDate(q.created_at)}</span>
                  <StatusBadge status={q.status} />
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
